"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8123],{

/***/ 10763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ ExpandableLabel; },
/* harmony export */   "N": function() { return /* binding */ ExpandableButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40447);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6260);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20253);
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5527);





var ExpandableButton = function ExpandableButton(param) {
    var onClick = param.onClick, expanded = param.expanded, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_IconButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        "aria-label": "Hide or show expandable content",
        onClick: onClick,
        children: [
            children,
            expanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                color: "invertedContrast"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                color: "invertedContrast"
            })
        ]
    });
};
ExpandableButton.defaultProps = {
    expanded: false
};
var ExpandableLabel = function ExpandableLabel(param) {
    var onClick = param.onClick, expanded = param.expanded, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        variant: "text",
        "aria-label": "Hide or show expandable content",
        onClick: onClick,
        endIcon: expanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            color: "primary"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            color: "primary"
        }),
        children: children
    });
};
ExpandableLabel.defaultProps = {
    expanded: false
};


/***/ }),

/***/ 12764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91186);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  &:before {\n    border-radius: 50%;\n    border: 1px solid rgba(0, 0, 0, 0.25);\n    content: "";\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: 7;\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TokenImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-cc5dea0d-0"
}).withConfig({
    componentId: "sc-3ddd1e56-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (TokenImage);


/***/ }),

/***/ 56503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Image_TokenPairImage; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Image/types.ts
var variants = {
    DEFAULT: "default",
    INVERTED: "inverted"
};

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
// EXTERNAL MODULE: ./packages/uikit/src/components/Image/TokenImage.tsx
var TokenImage = __webpack_require__(12764);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Image/styles.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: ",
        "; //92, 82 are arbitrary numbers to fit the variant\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 50%;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var _obj;
var StyledPrimaryImage = (0,styled_components_browser_esm/* default */.ZP)(TokenImage/* default */.Z).withConfig({
    componentId: "sc-6445b724-0"
}).withConfig({
    componentId: "sc-26caa618-0"
})(_templateObject(), function(param) {
    var variant = param.variant;
    return variant === variants.DEFAULT ? "92%" : "82%";
}, (0,index_esm/* variant */.bU)({
    variants: (_obj = {}, (0,_define_property/* default */.Z)(_obj, variants.DEFAULT, {
        bottom: "auto",
        left: 0,
        right: "auto",
        top: 0,
        zIndex: 5
    }), (0,_define_property/* default */.Z)(_obj, variants.INVERTED, {
        bottom: 0,
        left: "auto",
        right: 0,
        top: "auto",
        zIndex: 6
    }), _obj)
}));
var _obj1;
var StyledSecondaryImage = (0,styled_components_browser_esm/* default */.ZP)(TokenImage/* default */.Z).withConfig({
    componentId: "sc-6445b724-1"
}).withConfig({
    componentId: "sc-26caa618-1"
})(_templateObject1(), (0,index_esm/* variant */.bU)({
    variants: (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, variants.DEFAULT, {
        bottom: 0,
        left: "auto",
        right: 0,
        top: "auto",
        zIndex: 6
    }), (0,_define_property/* default */.Z)(_obj1, variants.INVERTED, {
        bottom: "auto",
        left: 0,
        right: "auto",
        top: 0,
        zIndex: 5
    }), _obj1)
}));

// EXTERNAL MODULE: ./packages/uikit/src/components/Image/Wrapper.tsx
var Wrapper = __webpack_require__(24364);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Image/TokenPairImage.tsx








var TokenPairImage = function TokenPairImage(_param) {
    var primarySrc = _param.primarySrc, secondarySrc = _param.secondarySrc, width = _param.width, height = _param.height, _variant = _param.variant, variant = _variant === void 0 ? variants.DEFAULT : _variant, _primaryImageProps = _param.primaryImageProps, primaryImageProps = _primaryImageProps === void 0 ? {} : _primaryImageProps, _secondaryImageProps = _param.secondaryImageProps, secondaryImageProps = _secondaryImageProps === void 0 ? {} : _secondaryImageProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "primarySrc",
        "secondarySrc",
        "width",
        "height",
        "variant",
        "primaryImageProps",
        "secondaryImageProps"
    ]);
    var secondaryImageSize = Math.floor(width / 2);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        position: "relative",
        width: width,
        height: height
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPrimaryImage, (0,_object_spread/* default */.Z)({
                variant: variant,
                src: primarySrc,
                width: width,
                height: height
            }, primaryImageProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSecondaryImage, (0,_object_spread/* default */.Z)({
                variant: variant,
                src: secondarySrc,
                width: secondaryImageSize,
                height: secondaryImageSize
            }, secondaryImageProps))
        ]
    }));
};
/* harmony default export */ var Image_TokenPairImage = (TokenPairImage);


/***/ }),

/***/ 543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 6372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17058);






var Icon = function Icon(props) {
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .Fg)();
    var primaryColor = theme.isDark ? "#FFFFFF" : "#0B3D91";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11 5V16.17L6.11997 11.29C5.72997 10.9 5.08997 10.9 4.69997 11.29C4.30997 11.68 4.30997 12.31 4.69997 12.7L11.29 19.29C11.68 19.68 12.31 19.68 12.7 19.29L19.29 12.7C19.68 12.31 19.68 11.68 19.29 11.29C18.9 10.9 18.27 10.9 17.88 11.29L13 16.17V5C13 4.45 12.55 4 12 4C11.45 4 11 4.45 11 5Z",
            fill: primaryColor
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 47509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17058);






var Icon = function Icon(props) {
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .Fg)();
    var primaryColor = theme.isDark ? "white" : "black";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        width: "17",
        height: "17",
        viewBox: "0 0 17 17"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M12.2988 1.5C12.564 1.5 12.8184 1.60536 13.0059 1.79289C13.1935 1.98043 13.2988 2.23478 13.2988 2.5V14.5C13.2988 14.7652 13.1935 15.0196 13.0059 15.2071C12.8184 15.3946 12.564 15.5 12.2988 15.5H4.29883C4.03361 15.5 3.77926 15.3946 3.59172 15.2071C3.40418 15.0196 3.29883 14.7652 3.29883 14.5V2.5C3.29883 2.23478 3.40418 1.98043 3.59172 1.79289C3.77926 1.60536 4.03361 1.5 4.29883 1.5H12.2988ZM4.29883 0.5C3.7684 0.5 3.25969 0.710714 2.88461 1.08579C2.50954 1.46086 2.29883 1.96957 2.29883 2.5V14.5C2.29883 15.0304 2.50954 15.5391 2.88461 15.9142C3.25969 16.2893 3.7684 16.5 4.29883 16.5H12.2988C12.8293 16.5 13.338 16.2893 13.713 15.9142C14.0881 15.5391 14.2988 15.0304 14.2988 14.5V2.5C14.2988 1.96957 14.0881 1.46086 13.713 1.08579C13.338 0.710714 12.8293 0.5 12.2988 0.5H4.29883Z",
                    fill: primaryColor
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M4.29883 3C4.29883 2.86739 4.35151 2.74021 4.44527 2.64645C4.53904 2.55268 4.66622 2.5 4.79883 2.5H11.7988C11.9314 2.5 12.0586 2.55268 12.1524 2.64645C12.2462 2.74021 12.2988 2.86739 12.2988 3V5C12.2988 5.13261 12.2462 5.25979 12.1524 5.35355C12.0586 5.44732 11.9314 5.5 11.7988 5.5H4.79883C4.66622 5.5 4.53904 5.44732 4.44527 5.35355C4.35151 5.25979 4.29883 5.13261 4.29883 5V3ZM4.29883 7C4.29883 6.86739 4.35151 6.74021 4.44527 6.64645C4.53904 6.55268 4.66622 6.5 4.79883 6.5H5.79883C5.93144 6.5 6.05861 6.55268 6.15238 6.64645C6.24615 6.74021 6.29883 6.86739 6.29883 7V8C6.29883 8.13261 6.24615 8.25979 6.15238 8.35355C6.05861 8.44732 5.93144 8.5 5.79883 8.5H4.79883C4.66622 8.5 4.53904 8.44732 4.44527 8.35355C4.35151 8.25979 4.29883 8.13261 4.29883 8V7ZM4.29883 10C4.29883 9.86739 4.35151 9.74021 4.44527 9.64645C4.53904 9.55268 4.66622 9.5 4.79883 9.5H5.79883C5.93144 9.5 6.05861 9.55268 6.15238 9.64645C6.24615 9.74021 6.29883 9.86739 6.29883 10V11C6.29883 11.1326 6.24615 11.2598 6.15238 11.3536C6.05861 11.4473 5.93144 11.5 5.79883 11.5H4.79883C4.66622 11.5 4.53904 11.4473 4.44527 11.3536C4.35151 11.2598 4.29883 11.1326 4.29883 11V10ZM4.29883 13C4.29883 12.8674 4.35151 12.7402 4.44527 12.6464C4.53904 12.5527 4.66622 12.5 4.79883 12.5H5.79883C5.93144 12.5 6.05861 12.5527 6.15238 12.6464C6.24615 12.7402 6.29883 12.8674 6.29883 13V14C6.29883 14.1326 6.24615 14.2598 6.15238 14.3536C6.05861 14.4473 5.93144 14.5 5.79883 14.5H4.79883C4.66622 14.5 4.53904 14.4473 4.44527 14.3536C4.35151 14.2598 4.29883 14.1326 4.29883 14V13ZM7.29883 7C7.29883 6.86739 7.35151 6.74021 7.44527 6.64645C7.53904 6.55268 7.66622 6.5 7.79883 6.5H8.79883C8.93144 6.5 9.05861 6.55268 9.15238 6.64645C9.24615 6.74021 9.29883 6.86739 9.29883 7V8C9.29883 8.13261 9.24615 8.25979 9.15238 8.35355C9.05861 8.44732 8.93144 8.5 8.79883 8.5H7.79883C7.66622 8.5 7.53904 8.44732 7.44527 8.35355C7.35151 8.25979 7.29883 8.13261 7.29883 8V7ZM7.29883 10C7.29883 9.86739 7.35151 9.74021 7.44527 9.64645C7.53904 9.55268 7.66622 9.5 7.79883 9.5H8.79883C8.93144 9.5 9.05861 9.55268 9.15238 9.64645C9.24615 9.74021 9.29883 9.86739 9.29883 10V11C9.29883 11.1326 9.24615 11.2598 9.15238 11.3536C9.05861 11.4473 8.93144 11.5 8.79883 11.5H7.79883C7.66622 11.5 7.53904 11.4473 7.44527 11.3536C7.35151 11.2598 7.29883 11.1326 7.29883 11V10ZM7.29883 13C7.29883 12.8674 7.35151 12.7402 7.44527 12.6464C7.53904 12.5527 7.66622 12.5 7.79883 12.5H8.79883C8.93144 12.5 9.05861 12.5527 9.15238 12.6464C9.24615 12.7402 9.29883 12.8674 9.29883 13V14C9.29883 14.1326 9.24615 14.2598 9.15238 14.3536C9.05861 14.4473 8.93144 14.5 8.79883 14.5H7.79883C7.66622 14.5 7.53904 14.4473 7.44527 14.3536C7.35151 14.2598 7.29883 14.1326 7.29883 14V13ZM10.2988 7C10.2988 6.86739 10.3515 6.74021 10.4453 6.64645C10.539 6.55268 10.6662 6.5 10.7988 6.5H11.7988C11.9314 6.5 12.0586 6.55268 12.1524 6.64645C12.2462 6.74021 12.2988 6.86739 12.2988 7V8C12.2988 8.13261 12.2462 8.25979 12.1524 8.35355C12.0586 8.44732 11.9314 8.5 11.7988 8.5H10.7988C10.6662 8.5 10.539 8.44732 10.4453 8.35355C10.3515 8.25979 10.2988 8.13261 10.2988 8V7ZM10.2988 10C10.2988 9.86739 10.3515 9.74021 10.4453 9.64645C10.539 9.55268 10.6662 9.5 10.7988 9.5H11.7988C11.9314 9.5 12.0586 9.55268 12.1524 9.64645C12.2462 9.74021 12.2988 9.86739 12.2988 10V14C12.2988 14.1326 12.2462 14.2598 12.1524 14.3536C12.0586 14.4473 11.9314 14.5 11.7988 14.5H10.7988C10.6662 14.5 10.539 14.4473 10.4453 14.3536C10.3515 14.2598 10.2988 14.1326 10.2988 14V10Z",
                    fill: primaryColor
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 11051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "25",
            height: "25",
            viewBox: "0 0 25 25",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M11 21.8147C11 21.8147 9.5 21.8147 9.5 20.3147C9.5 18.8147 11 14.3147 17 14.3147C23 14.3147 24.5 18.8147 24.5 20.3147C24.5 21.8147 23 21.8147 23 21.8147H11ZM17 12.8147C18.1935 12.8147 19.3381 12.3406 20.182 11.4967C21.0259 10.6528 21.5 9.50817 21.5 8.3147C21.5 7.12122 21.0259 5.97663 20.182 5.13272C19.3381 4.2888 18.1935 3.8147 17 3.8147C15.8065 3.8147 14.6619 4.2888 13.818 5.13272C12.9741 5.97663 12.5 7.12122 12.5 8.3147C12.5 9.50817 12.9741 10.6528 13.818 11.4967C14.6619 12.3406 15.8065 12.8147 17 12.8147V12.8147Z",
                    fill: "#A176F3"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M8.324 21.8147C8.10163 21.3464 7.99073 20.833 8 20.3147C8 18.2822 9.02 16.1897 10.904 14.7347C9.96364 14.445 8.98392 14.3033 8 14.3147C2 14.3147 0.5 18.8147 0.5 20.3147C0.5 21.8147 2 21.8147 2 21.8147H8.324Z",
                    fill: "#A176F3"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M7.25 12.8147C8.24456 12.8147 9.19839 12.4196 9.90165 11.7163C10.6049 11.0131 11 10.0593 11 9.0647C11 8.07014 10.6049 7.11631 9.90165 6.41305C9.19839 5.70979 8.24456 5.3147 7.25 5.3147C6.25544 5.3147 5.30161 5.70979 4.59835 6.41305C3.89509 7.11631 3.5 8.07014 3.5 9.0647C3.5 10.0593 3.89509 11.0131 4.59835 11.7163C5.30161 12.4196 6.25544 12.8147 7.25 12.8147V12.8147Z",
                    fill: "#A176F3"
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 72943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M18 13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 22491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M15.0701 1.01H9.07007V3.01H15.0701V1.01ZM11.0701 14.01H13.0701V8.01H11.0701V14.01ZM19.1001 7.39L20.5201 5.97C20.0901 5.46 19.6201 4.98 19.1101 4.56L17.6901 5.98C16.1401 4.74 14.1901 4 12.0701 4C7.10007 4 3.07007 8.03 3.07007 13C3.07007 17.97 7.09007 22 12.0701 22C17.0501 22 21.0701 17.97 21.0701 13C21.0701 10.89 20.3301 8.94 19.1001 7.39ZM12.0701 20.01C8.20007 20.01 5.07007 16.88 5.07007 13.01C5.07007 9.14 8.20007 6.01 12.0701 6.01C15.9401 6.01 19.0701 9.14 19.0701 13.01C19.0701 16.88 15.9401 20.01 12.0701 20.01Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 29502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M23 12L20.56 9.21L20.9 5.52L17.29 4.7L15.4 1.5L12 2.96L8.6 1.5L6.71 4.69L3.1 5.5L3.44 9.2L1 12L3.44 14.79L3.1 18.49L6.71 19.31L8.6 22.5L12 21.03L15.4 22.49L17.29 19.3L20.9 18.48L20.56 14.79L23 12ZM9.38 16.01L7 13.61C6.61 13.22 6.61 12.59 7 12.2L7.07 12.13C7.46 11.74 8.1 11.74 8.49 12.13L10.1 13.75L15.25 8.59C15.64 8.2 16.28 8.2 16.67 8.59L16.74 8.66C17.13 9.05 17.13 9.68 16.74 10.07L10.82 16.01C10.41 16.4 9.78 16.4 9.38 16.01Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 17634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97114);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: ",
        ";\n  text-underline-offset: 0.1em;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TooltipText = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-987d539-0"
}).withConfig({
    componentId: "sc-ac8eb226-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return "underline dotted ".concat(theme.colors.textSubtle);
});
/* harmony default export */ __webpack_exports__["Z"] = (TooltipText);


/***/ }),

/***/ 20922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sC": function() { return /* binding */ BalanceWithLoading; }
/* harmony export */ });
/* unused harmony export AnimatedBalance */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44747);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(84091);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_countup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17857);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(19521);
/* harmony import */ var utils_isUndefinedOrNull__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(12157);
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14841);
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_toNumber__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_isNaN__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7654);
/* harmony import */ var lodash_isNaN__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isNaN__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_replace__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13880);
/* harmony import */ var lodash_replace__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_replace__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lodash_toString__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79833);
/* harmony import */ var lodash_toString__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_toString__WEBPACK_IMPORTED_MODULE_7__);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {\n    opacity: 0;\n  }\n  \n  to {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  animation: ",
        " 0.65s ease-in-out forwards;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var Balance = function(_param) {
    var value = _param.value, _color = _param.color, color = _color === void 0 ? "text" : _color, _decimals = _param.decimals, decimals = _decimals === void 0 ? 3 : _decimals, _isDisabled = _param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, unit = _param.unit, prefix = _param.prefix, onClick = _param.onClick, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "value",
        "color",
        "decimals",
        "isDisabled",
        "unit",
        "prefix",
        "onClick"
    ]);
    var previousValue = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        previousValue.current = value;
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        color: isDisabled ? "textDisabled" : color,
        onClick: onClick
    }, props), {
        children: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react_countup__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
            start: previousValue.current,
            end: value,
            prefix: prefix || "",
            suffix: unit || "",
            // eslint-disable-next-line object-shorthand
            decimals: decimals,
            duration: 1,
            separator: ","
        })
    }));
};
var BalanceWithLoading = function(_param) {
    var value = _param.value, fontSize = _param.fontSize, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "value",
        "fontSize"
    ]);
    if ((0,utils_isUndefinedOrNull__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(value)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {});
    }
    var trimmedValue = lodash_replace__WEBPACK_IMPORTED_MODULE_6___default()(lodash_toString__WEBPACK_IMPORTED_MODULE_7___default()(value), /,/g, "");
    var finalValue = lodash_isNaN__WEBPACK_IMPORTED_MODULE_5___default()(trimmedValue) || lodash_isNaN__WEBPACK_IMPORTED_MODULE_5___default()(lodash_toNumber__WEBPACK_IMPORTED_MODULE_4___default()(trimmedValue)) ? 0 : lodash_toNumber__WEBPACK_IMPORTED_MODULE_4___default()(trimmedValue);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Balance, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, props), {
        value: finalValue,
        fontSize: fontSize
    }));
};
var appear = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* .keyframes */ .F4)(_templateObject());
var AnimatedBalance = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(Balance).withConfig({
    componentId: "sc-e7b1ff81-0"
})(_templateObject1(), appear);
/* harmony default export */ __webpack_exports__["ZP"] = (Balance);


/***/ }),

/***/ 40508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ FlexGap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4318);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  & > * {\n    min-width: 280px;\n    max-width: 31.5%;\n    width: 100%;\n    margin: 0 8px;\n    margin-bottom: 32px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  gap: ",
        ";\n  row-gap: ",
        ";\n  column-gap: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var FlexLayout = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e479e0f6-0"
})(_templateObject());
var FlexGap = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e479e0f6-1"
})(_templateObject1(), function(param) {
    var gap = param.gap;
    return gap;
}, function(param) {
    var rowGap = param.rowGap;
    return rowGap;
}, function(param) {
    var columnGap = param.columnGap;
    return columnGap;
});
/* harmony default export */ __webpack_exports__["Z"] = (FlexLayout);


/***/ }),

/***/ 97977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_RoiCalculatorModal; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(90452);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenu.tsx
var ButtonMenu = __webpack_require__(50156);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(36544);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/BalanceInput/BalanceInput.tsx + 2 modules
var BalanceInput = __webpack_require__(35680);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 1 modules
var Button = __webpack_require__(20253);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Help.tsx
var Help = __webpack_require__(62276);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenuItem.tsx
var ButtonMenuItem = __webpack_require__(39320);
// EXTERNAL MODULE: ./packages/uikit/src/components/Checkbox/Checkbox.tsx + 1 modules
var Checkbox = __webpack_require__(19731);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/ExpandableButton.tsx
var ExpandableButton = __webpack_require__(10763);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Grid.tsx
var Grid = __webpack_require__(26170);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(10566);
// EXTERNAL MODULE: ./src/utils/compoundApyHelpers.ts
var compoundApyHelpers = __webpack_require__(43452);
;// CONCATENATED MODULE: ./src/components/RoiCalculatorModal/RoiCalculatorFooter.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style-type: none;\n  margin-top: 16px;\n  padding: 0;\n  li {\n    margin: 0;\n    padding: 0;\n  }\n  li::before {\n    content: '•';\n    margin-right: 4px;\n    color: ",
        ";\n  }\n  li::marker {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var Footer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e3f8e391-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.dropdown;
});
var BulletList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-e3f8e391-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var RoiCalculatorFooter = function(param) {
    var isFarm = param.isFarm, apr = param.apr, apy = param.apy, displayApr = param.displayApr, autoCompoundFrequency = param.autoCompoundFrequency, multiplier = param.multiplier, linkLabel = param.linkLabel, linkHref = param.linkHref, performanceFee = param.performanceFee;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref1 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("The Multiplier represents the proportion of CAKE rewards each farm receives, as a proportion of the CAKE produced each block.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                my: "24px",
                children: t("For example, if a 1x farm received 1 CAKE per block, a 40x farm would receive 40 CAKE per block.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("This amount is already included in all APR calculations for the farm.")
            })
        ]
    }), {
        placement: "top-end",
        tooltipOffset: [
            20,
            10
        ]
    }), multiplierRef = ref1.targetRef, multiplierTooltip = ref1.tooltip, multiplierTooltipVisible = ref1.tooltipVisible;
    var gridRowCount = isFarm ? 4 : 2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer, {
        p: "16px",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableButton/* ExpandableLabel */.L, {
                expanded: isExpanded,
                onClick: function() {
                    return setIsExpanded(function(prev) {
                        return !prev;
                    });
                },
                children: isExpanded ? t("Hide") : t("Details")
            }),
            isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                px: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        gridTemplateColumns: "2.5fr 1fr",
                        gridRowGap: "8px",
                        gridTemplateRows: "repeat(".concat(gridRowCount, ", auto)"),
                        children: [
                            isFarm && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "textSubtle",
                                        small: true,
                                        children: t("APR (incl. LP rewards)")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        small: true,
                                        textAlign: "right",
                                        children: [
                                            displayApr,
                                            "%"
                                        ]
                                    })
                                ]
                            }),
                            !Number.isFinite(apy) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "textSubtle",
                                small: true,
                                children: isFarm ? t("Base APR (CAKE yield only)") : t("APR")
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "textSubtle",
                                small: true,
                                children: t("APY")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                small: true,
                                textAlign: "right",
                                children: [
                                    (apy !== null && apy !== void 0 ? apy : apr).toFixed(2),
                                    "%"
                                ]
                            }),
                            !Number.isFinite(apy) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "textSubtle",
                                small: true,
                                children: t("APY (%compoundTimes%x daily compound)", {
                                    compoundTimes: autoCompoundFrequency > 0 ? autoCompoundFrequency : 1
                                })
                            }),
                            !Number.isFinite(apy) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                small: true,
                                textAlign: "right",
                                children: [
                                    ((0,compoundApyHelpers/* getApy */.g5)(apr, autoCompoundFrequency > 0 ? autoCompoundFrequency : 1, 365, performanceFee) * 100).toFixed(2),
                                    "%"
                                ]
                            }),
                            isFarm && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "textSubtle",
                                        small: true,
                                        children: t("Farm Multiplier")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        justifyContent: "flex-end",
                                        alignItems: "flex-end",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                small: true,
                                                textAlign: "right",
                                                mr: "4px",
                                                children: multiplier
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                ref: multiplierRef,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                                                    color: "textSubtle",
                                                    width: "16px",
                                                    height: "16px"
                                                })
                                            }),
                                            multiplierTooltipVisible && multiplierTooltip
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BulletList, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "12px",
                                    textAlign: "center",
                                    color: "textSubtle",
                                    display: "inline",
                                    lineHeight: 1.1,
                                    children: t("Calculated based on current rates.")
                                })
                            }),
                            isFarm && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "12px",
                                    textAlign: "center",
                                    color: "textSubtle",
                                    display: "inline",
                                    children: t("LP rewards: 0.17% trading fees, distributed proportionally among LP token holders.")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "12px",
                                    textAlign: "center",
                                    color: "textSubtle",
                                    display: "inline",
                                    lineHeight: 1.1,
                                    children: t("All figures are estimates provided for your convenience only, and by no means represent guaranteed returns.")
                                })
                            }),
                            performanceFee > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    mt: "14px",
                                    fontSize: "12px",
                                    textAlign: "center",
                                    color: "textSubtle",
                                    display: "inline",
                                    children: t("All estimated rates take into account this pool’s %fee%% performance fee", {
                                        fee: performanceFee
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justifyContent: "center",
                        mt: "24px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                            href: linkHref,
                            children: linkLabel
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RoiCalculatorModal_RoiCalculatorFooter = (RoiCalculatorFooter);

// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(5324);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Checkmark.tsx
var Checkmark = __webpack_require__(60526);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(17058);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Svg/Icons/Pencil.tsx






var Icon = function Icon(props) {
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var primaryColor = theme.isDark ? "#FFFFFF" : "#0B3D91";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 19 19"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0 15.46V18.5C0 18.78 0.22 19 0.5 19H3.54C3.67 19 3.8 18.95 3.89 18.85L14.81 7.94L11.06 4.19L0.15 15.1C0.0500001 15.2 0 15.32 0 15.46ZM17.71 5.04C18.1 4.65 18.1 4.02 17.71 3.63L15.37 1.29C14.98 0.899998 14.35 0.899998 13.96 1.29L12.13 3.12L15.88 6.87L17.71 5.04Z",
            fill: primaryColor
        })
    }));
};
/* harmony default export */ var Pencil = (Icon);

// EXTERNAL MODULE: ./src/components/RoiCalculatorModal/useRoiCalculatorReducer.ts
var useRoiCalculatorReducer = __webpack_require__(44307);
;// CONCATENATED MODULE: ./src/components/RoiCalculatorModal/RoiCard.tsx

function RoiCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: 1px;\n  width: 100%;\n  border-radius: ",
        ";\n"
    ]);
    RoiCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RoiCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 120px;\n  padding: 24px;\n  border-radius: ",
        ";\n  background: ",
        ";\n"
    ]);
    RoiCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  & > input {\n    padding-left: 28px;\n    max-width: 70%;\n  }\n  &:before {\n    position: absolute;\n    content: '$';\n    color: ",
        ";\n    left: 16px;\n    top: 8px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 82%;\n  margin-right: 8px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow-x: auto;\n  &::-webkit-scrollbar {\n    height: 0px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var MILLION = 1000000;
var TRILLION = 1000000000000;
var RoiCardWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-d8f2de20-0"
})(RoiCard_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme;
    return theme.radii.default;
});
var RoiCardInner = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-d8f2de20-1"
})(RoiCard_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.radii.default;
}, function(param) {
    var theme = param.theme;
    return theme.colors.input;
});
var RoiInputContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-d8f2de20-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var RoiDisplayContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d8f2de20-3"
})(_templateObject3());
var RoiDollarAmount = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-d8f2de20-4"
})(_templateObject4(), function(param) {
    var fadeOut = param.fadeOut, theme = param.theme;
    return fadeOut && "\n      &:after {\n        background: linear-gradient(\n          to right,\n          ".concat(theme.colors.background, "00,\n          ").concat(theme.colors.background, "E6\n        );\n        content: '';\n        height: 100%;\n        pointer-events: none;\n        position: absolute;\n        right: 0;\n        top: 0;\n        width: 40px;\n      }\n  ");
});
var RoiCard = function(param) {
    var earningTokenSymbol = param.earningTokenSymbol, calculatorState = param.calculatorState, setTargetRoi = param.setTargetRoi, setCalculatorMode = param.setCalculatorMode;
    var ref = (0,react.useState)(""), expectedRoi = ref[0], setExpectedRoi = ref[1];
    var inputRef = (0,react.useRef)(null);
    var _data = calculatorState.data, roiUSD = _data.roiUSD, roiTokens = _data.roiTokens, roiPercentage = _data.roiPercentage;
    var mode = calculatorState.controls.mode;
    var t = (0,Localization/* useTranslation */.$G)().t;
    (0,react.useEffect)(function() {
        if (mode === useRoiCalculatorReducer/* CalculatorMode.PRINCIPAL_BASED_ON_ROI */.ee.PRINCIPAL_BASED_ON_ROI && inputRef.current) {
            inputRef.current.focus();
        }
    }, [
        mode
    ]);
    var onEnterEditing = function() {
        setCalculatorMode(useRoiCalculatorReducer/* CalculatorMode.PRINCIPAL_BASED_ON_ROI */.ee.PRINCIPAL_BASED_ON_ROI);
        setExpectedRoi(roiUSD.toLocaleString("en", {
            minimumFractionDigits: roiUSD > MILLION ? 0 : 2,
            maximumFractionDigits: roiUSD > MILLION ? 0 : 2
        }));
    };
    var onExitRoiEditing = function() {
        setCalculatorMode(useRoiCalculatorReducer/* CalculatorMode.ROI_BASED_ON_PRINCIPAL */.ee.ROI_BASED_ON_PRINCIPAL);
    };
    var handleExpectedRoiChange = function(event) {
        if (event.currentTarget.validity.valid) {
            var roiAsString = event.target.value.replace(/,/g, ".");
            setTargetRoi(roiAsString);
            setExpectedRoi(roiAsString);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiCardWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RoiCardInner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "12px",
                    color: "secondary",
                    bold: true,
                    textTransform: "uppercase",
                    children: t("ROI at current rates")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    mt: "4px",
                    height: "36px",
                    children: mode === useRoiCalculatorReducer/* CalculatorMode.PRINCIPAL_BASED_ON_ROI */.ee.PRINCIPAL_BASED_ON_ROI ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiInputContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    ref: inputRef,
                                    type: "text",
                                    inputMode: "decimal",
                                    pattern: "^[0-9]+[.,]?[0-9]*$",
                                    scale: "sm",
                                    value: expectedRoi,
                                    placeholder: "0.0",
                                    onChange: handleExpectedRoiChange
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                scale: "sm",
                                variant: "text",
                                onClick: onExitRoiEditing,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkmark/* default */.Z, {
                                    color: "primary"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RoiDisplayContainer, {
                                onClick: onEnterEditing,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "24px",
                                        bold: true,
                                        children: "$"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiDollarAmount, {
                                        fontSize: "24px",
                                        bold: true,
                                        fadeOut: roiUSD > TRILLION,
                                        children: roiUSD.toLocaleString("en", {
                                            minimumFractionDigits: roiUSD > MILLION ? 0 : 2,
                                            maximumFractionDigits: roiUSD > MILLION ? 0 : 2
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                scale: "sm",
                                variant: "text",
                                onClick: onEnterEditing,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pencil, {
                                    color: "primary"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    fontSize: "12px",
                    color: "textSubtle",
                    children: [
                        "~ ",
                        roiTokens,
                        " ",
                        earningTokenSymbol,
                        " (",
                        roiPercentage.toLocaleString("en", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }),
                        "%)"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var RoiCalculatorModal_RoiCard = (RoiCard);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowDown.tsx
var ArrowDown = __webpack_require__(6372);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowUp.tsx
var ArrowUp = __webpack_require__(16274);
;// CONCATENATED MODULE: ./src/components/RoiCalculatorModal/AnimatedArrow.tsx

function AnimatedArrow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: scale(1);\n    stroke-width: 0;\n  }\n  50% {\n    transform: scale(1.3);\n    stroke-width: 2;\n  }\n  100% {\n    transform: scale(1);\n    stroke-width: 0;\n  }\n"
    ]);
    AnimatedArrow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AnimatedArrow_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > svg {\n    animation: 0.2s ",
        " linear;\n    stroke: ",
        ";\n    stroke-width: 0;\n  }\n"
    ]);
    AnimatedArrow_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var rotate = (0,styled_components_browser_esm/* keyframes */.F4)(AnimatedArrow_templateObject());
var ArrowContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-3ceab9e8-0"
})(AnimatedArrow_templateObject1(), rotate, function(param) {
    var theme = param.theme;
    return "".concat(theme.colors.primary, "3D");
});
var AnimatedArrow = function(param) {
    var calculatorState = param.calculatorState;
    var ref = (0,react.useState)("roiArrow-0"), key = ref[0], setKey = ref[1];
    var mode = calculatorState.controls.mode;
    // Trigger animation on state change
    (0,react.useEffect)(function() {
        setKey(function(prevKey) {
            var prevId = parseInt(prevKey.split("-")[1], 10);
            return "roiArrow-".concat(prevId + 1);
        });
    }, [
        calculatorState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowContainer, {
        justifyContent: "center",
        my: "24px",
        children: mode === useRoiCalculatorReducer/* CalculatorMode.ROI_BASED_ON_PRINCIPAL */.ee.ROI_BASED_ON_PRINCIPAL ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
            width: "24px",
            height: "24px",
            color: "textSubtle"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* default */.Z, {
            width: "24px",
            height: "24px",
            color: "textSubtle"
        })
    }, key);
};
/* harmony default export */ var RoiCalculatorModal_AnimatedArrow = (AnimatedArrow);

;// CONCATENATED MODULE: ./src/components/RoiCalculatorModal/index.tsx

function RoiCalculatorModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 380px;\n  & > :nth-child(2) {\n    padding: 0;\n  }\n"
    ]);
    RoiCalculatorModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RoiCalculatorModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n  max-height: 500px;\n  overflow-y: auto;\n  ",
        " {\n    max-height: none;\n  }\n"
    ]);
    RoiCalculatorModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RoiCalculatorModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  & > button {\n    width: 100%;\n  }\n\n  opacity: ",
        ";\n"
    ]);
    RoiCalculatorModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var StyledModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-f83d90d9-0"
})(RoiCalculatorModal_templateObject());
var ScrollableContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f83d90d9-1"
})(RoiCalculatorModal_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var FullWidthButtonMenu = (0,styled_components_browser_esm/* default */.ZP)(ButtonMenu/* default */.Z).withConfig({
    componentId: "sc-f83d90d9-2"
})(RoiCalculatorModal_templateObject2(), function(param) {
    var disabled = param.disabled;
    return disabled ? 0.5 : 1;
});
var RoiCalculatorModal = function(param) {
    var onDismiss = param.onDismiss, onBack = param.onBack, earningTokenPrice = param.earningTokenPrice, apr = param.apr, apy = param.apy, displayApr = param.displayApr, linkLabel = param.linkLabel, linkHref = param.linkHref, stakingTokenBalance = param.stakingTokenBalance, stakingTokenSymbol = param.stakingTokenSymbol, stakingTokenPrice = param.stakingTokenPrice, multiplier = param.multiplier, initialValue = param.initialValue, _earningTokenSymbol = param.earningTokenSymbol, earningTokenSymbol = _earningTokenSymbol === void 0 ? "RP1" : _earningTokenSymbol, _autoCompoundFrequency = param.autoCompoundFrequency, autoCompoundFrequency = _autoCompoundFrequency === void 0 ? 0 : _autoCompoundFrequency, _performanceFee = param.performanceFee, performanceFee = _performanceFee === void 0 ? 0 : _performanceFee, _isFarm = param.isFarm, isFarm = _isFarm === void 0 ? false : _isFarm, initialState = param.initialState, strategy = param.strategy, header = param.header, children = param.children;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var balanceInputRef = (0,react.useRef)(null);
    var ref = (0,useRoiCalculatorReducer/* default */.ZP)({
        stakingTokenPrice: stakingTokenPrice,
        earningTokenPrice: earningTokenPrice,
        autoCompoundFrequency: autoCompoundFrequency
    }, initialState), state = ref.state, setPrincipalFromUSDValue = ref.setPrincipalFromUSDValue, setPrincipalFromTokenValue = ref.setPrincipalFromTokenValue, setStakingDuration = ref.setStakingDuration, toggleCompounding = ref.toggleCompounding, toggleEditingCurrency = ref.toggleEditingCurrency, setCompoundingFrequency = ref.setCompoundingFrequency, setCalculatorMode = ref.setCalculatorMode, setTargetRoi = ref.setTargetRoi, dispatch = ref.dispatch;
    var _controls = state.controls, compounding = _controls.compounding, activeCompoundingIndex = _controls.activeCompoundingIndex, stakingDuration = _controls.stakingDuration, editingCurrency = _controls.editingCurrency;
    var _data = state.data, principalAsUSD = _data.principalAsUSD, principalAsToken = _data.principalAsToken;
    // Auto-focus input on opening modal
    (0,react.useEffect)(function() {
        if (balanceInputRef.current) {
            balanceInputRef.current.focus();
        }
    }, []);
    // If user comes to calculator from staking modal - initialize with whatever they put in there
    (0,react.useEffect)(function() {
        if (initialValue) {
            setPrincipalFromTokenValue(initialValue);
        }
    }, [
        initialValue,
        setPrincipalFromTokenValue
    ]);
    var ref1 = (0,useTooltip/* default */.Z)(isFarm ? t("“My Balance” here includes both LP Tokens in your wallet, and LP Tokens already staked in this farm.") : t("“My Balance” here includes both %assetSymbol% in your wallet, and %assetSymbol% already staked in this pool.", {
        assetSymbol: stakingTokenSymbol
    }), {
        placement: "top-end",
        tooltipOffset: [
            20,
            10
        ]
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    var onBalanceFocus = function() {
        setCalculatorMode(useRoiCalculatorReducer/* CalculatorMode.ROI_BASED_ON_PRINCIPAL */.ee.ROI_BASED_ON_PRINCIPAL);
    };
    var editingUnit = editingCurrency === useRoiCalculatorReducer/* EditingCurrency.TOKEN */.We.TOKEN ? stakingTokenSymbol : "USD";
    var editingValue = editingCurrency === useRoiCalculatorReducer/* EditingCurrency.TOKEN */.We.TOKEN ? principalAsToken : principalAsUSD;
    var conversionUnit = editingCurrency === useRoiCalculatorReducer/* EditingCurrency.TOKEN */.We.TOKEN ? "USD" : stakingTokenSymbol;
    var conversionValue = editingCurrency === useRoiCalculatorReducer/* EditingCurrency.TOKEN */.We.TOKEN ? principalAsUSD : principalAsToken;
    var onUserInput = editingCurrency === useRoiCalculatorReducer/* EditingCurrency.TOKEN */.We.TOKEN ? setPrincipalFromTokenValue : setPrincipalFromUSDValue;
    var DURATION = (0,react.useMemo)(function() {
        return [
            t("1D"),
            t("7D"),
            t("30D"),
            t("1Y"),
            t("5Y")
        ];
    }, [
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModal, {
        title: t("ROI Calculator"),
        onDismiss: onBack || onDismiss,
        onBack: onBack !== null && onBack !== void 0 ? onBack : null,
        headerBackground: "gradients.cardHeader",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollableContainer, {
                children: [
                    strategy ? strategy(state, dispatch) : /*#__PURE__*/ (0,jsx_runtime.jsx)(useRoiCalculatorReducer/* DefaultCompoundStrategy */.dw, {
                        apr: apy !== null && apy !== void 0 ? apy : apr,
                        dispatch: dispatch,
                        state: state,
                        earningTokenPrice: earningTokenPrice,
                        performanceFee: performanceFee,
                        stakingTokenPrice: stakingTokenPrice
                    }),
                    header,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        mb: "8px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "secondary",
                                bold: true,
                                fontSize: "12px",
                                textTransform: "uppercase",
                                children: t("%asset% staked", {
                                    asset: stakingTokenSymbol
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceInput/* default */.Z, {
                                inputProps: {
                                    scale: "sm"
                                },
                                currencyValue: "".concat(conversionValue, " ").concat(conversionUnit),
                                innerRef: balanceInputRef,
                                placeholder: "0.00",
                                value: editingValue,
                                unit: editingUnit,
                                onUserInput: onUserInput,
                                switchEditingUnits: toggleEditingCurrency,
                                onFocus: onBalanceFocus
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justifyContent: "space-between",
                                mt: "8px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        scale: "xs",
                                        p: "4px 16px",
                                        width: "68px",
                                        variant: "text",
                                        onClick: function() {
                                            return setPrincipalFromUSDValue("100");
                                        },
                                        children: "$100"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        scale: "xs",
                                        p: "4px 16px",
                                        width: "68px",
                                        variant: "text",
                                        onClick: function() {
                                            return setPrincipalFromUSDValue("1000");
                                        },
                                        children: "$1000"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        disabled: !Number.isFinite(stakingTokenPrice) || !stakingTokenBalance.isFinite() || stakingTokenBalance.lte(0) || !account,
                                        scale: "xs",
                                        p: "4px 16px",
                                        width: "128px",
                                        variant: "text",
                                        onClick: function() {
                                            return setPrincipalFromUSDValue((0,formatBalance/* getBalanceNumber */.mW)(stakingTokenBalance.times(stakingTokenPrice)).toString());
                                        },
                                        children: t("My Balance").toLocaleUpperCase()
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        ref: targetRef,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                                            width: "16px",
                                            height: "16px",
                                            color: "textSubtle"
                                        })
                                    }),
                                    tooltipVisible && tooltip
                                ]
                            }),
                            children || /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mt: "24px",
                                        color: "secondary",
                                        bold: true,
                                        fontSize: "12px",
                                        textTransform: "uppercase",
                                        children: t("Staked for")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthButtonMenu, {
                                        activeIndex: stakingDuration,
                                        onItemClick: setStakingDuration,
                                        scale: "sm",
                                        children: DURATION.map(function(duration) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                                variant: "light",
                                                children: duration
                                            }, duration);
                                        })
                                    })
                                ]
                            }),
                            autoCompoundFrequency === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mt: "24px",
                                        color: "secondary",
                                        bold: true,
                                        fontSize: "12px",
                                        textTransform: "uppercase",
                                        children: t("Compounding every")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                flex: "1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                    scale: "sm",
                                                    checked: compounding,
                                                    onChange: toggleCompounding
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                flex: "6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullWidthButtonMenu, {
                                                    disabled: !compounding,
                                                    activeIndex: activeCompoundingIndex,
                                                    onItemClick: setCompoundingFrequency,
                                                    scale: "sm",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                                            children: t("1D")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                                            children: t("7D")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                                            children: t("14D")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                                            children: t("30D")
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiCalculatorModal_AnimatedArrow, {
                        calculatorState: state
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiCalculatorModal_RoiCard, {
                            earningTokenSymbol: earningTokenSymbol,
                            calculatorState: state,
                            setTargetRoi: setTargetRoi,
                            setCalculatorMode: setCalculatorMode
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiCalculatorModal_RoiCalculatorFooter, {
                isFarm: isFarm,
                apr: apr,
                apy: apy,
                displayApr: displayApr,
                autoCompoundFrequency: autoCompoundFrequency,
                multiplier: multiplier,
                linkLabel: linkLabel,
                linkHref: linkHref,
                performanceFee: performanceFee
            })
        ]
    });
};
/* harmony default export */ var components_RoiCalculatorModal = (RoiCalculatorModal);


/***/ }),

/***/ 44307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "We": function() { return /* binding */ EditingCurrency; },
/* harmony export */   "dw": function() { return /* binding */ DefaultCompoundStrategy; },
/* harmony export */   "ee": function() { return /* binding */ CalculatorMode; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52875);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70794);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82492);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_compoundApyHelpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43452);






/**
 * This hook is handling all the calculator state and calculations.
 * UI connected to it is merely representation of the data and buttons to trigger actions
 */ // Mapping from the compounding frequency button index to actual compounding frequency
// in number of compounds per day
var compoundingIndexToFrequency = {
    0: 1,
    1: 0.142857142,
    2: 0.071428571,
    3: 0.033333333
};
var TOKEN_PRECISION = 10;
var USD_PRECISION = 2;
var EditingCurrency;
(function(EditingCurrency) {
    EditingCurrency[EditingCurrency["TOKEN"] = 0] = "TOKEN";
    EditingCurrency[EditingCurrency["USD"] = 1] = "USD";
})(EditingCurrency || (EditingCurrency = {}));
var CalculatorMode;
(function(CalculatorMode) {
    CalculatorMode[CalculatorMode["ROI_BASED_ON_PRINCIPAL"] = 0] = "ROI_BASED_ON_PRINCIPAL";
    CalculatorMode[CalculatorMode["PRINCIPAL_BASED_ON_ROI"] = 1] = "PRINCIPAL_BASED_ON_ROI";
})(CalculatorMode || (CalculatorMode = {}));
var defaultState = {
    controls: {
        compounding: true,
        compoundingFrequency: 1,
        activeCompoundingIndex: 0,
        stakingDuration: 3,
        mode: CalculatorMode.ROI_BASED_ON_PRINCIPAL,
        editingCurrency: EditingCurrency.USD
    },
    data: {
        principalAsToken: "0.00",
        principalAsUSD: "",
        roiUSD: 0,
        roiTokens: 0,
        roiPercentage: 0
    }
};
var roiCalculatorReducer = function(state, action) {
    switch(action.type){
        case "setStakingDuration":
            {
                var controls = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state.controls), {
                    stakingDuration: action.payload
                });
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state), {
                    controls: controls
                });
            }
        case "toggleCompounding":
            {
                var toggledCompounding = !state.controls.compounding;
                var controls1 = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state.controls), {
                    compounding: toggledCompounding
                });
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state), {
                    controls: controls1
                });
            }
        case "setCompoundingFrequency":
            {
                var _payload = action.payload, index = _payload.index, autoCompoundFrequency = _payload.autoCompoundFrequency;
                if (autoCompoundFrequency) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state), {
                        controls: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state.controls), {
                            compoundingFrequency: autoCompoundFrequency
                        })
                    });
                }
                var compoundingFrequency = compoundingIndexToFrequency[index];
                var controls2 = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state.controls), {
                    compoundingFrequency: compoundingFrequency,
                    activeCompoundingIndex: index
                });
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state), {
                    controls: controls2
                });
            }
        case "setPrincipal":
            {
                var _payload1 = action.payload, principalAsUSD = _payload1.principalAsUSD, principalAsToken = _payload1.principalAsToken;
                var data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state.data), {
                    principalAsUSD: principalAsUSD,
                    principalAsToken: principalAsToken
                });
                var controls3 = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state.controls), {
                    mode: CalculatorMode.ROI_BASED_ON_PRINCIPAL
                });
                return {
                    controls: controls3,
                    data: data
                };
            }
        case "setPrincipalForTargetRoi":
            {
                var _payload2 = action.payload, principalAsUSD1 = _payload2.principalAsUSD, principalAsToken1 = _payload2.principalAsToken, roiPercentage = _payload2.roiPercentage;
                var data1 = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state.data), {
                    principalAsUSD: principalAsUSD1,
                    principalAsToken: principalAsToken1,
                    roiPercentage: roiPercentage
                });
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state), {
                    data: data1
                });
            }
        case "setCalculatorMode":
            {
                var mode = action.payload;
                var controls4 = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state.controls), {
                    mode: mode
                });
                if (mode === CalculatorMode.PRINCIPAL_BASED_ON_ROI) {
                    var roiUSD = parseFloat(state.data.roiUSD.toFixed(USD_PRECISION));
                    var data2 = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state.data), {
                        roiUSD: roiUSD
                    });
                    return {
                        controls: controls4,
                        data: data2
                    };
                }
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state), {
                    controls: controls4
                });
            }
        case "setRoi":
            {
                var data3 = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state.data, action.payload);
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state), {
                    data: data3
                });
            }
        case "setTargetRoi":
            {
                var _payload3 = action.payload, roiUSD1 = _payload3.roiUSD, roiTokens = _payload3.roiTokens;
                var data4 = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state.data), {
                    roiUSD: roiUSD1,
                    roiTokens: roiTokens
                });
                var controls5 = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state.controls), {
                    mode: CalculatorMode.PRINCIPAL_BASED_ON_ROI
                });
                return {
                    controls: controls5,
                    data: data4
                };
            }
        case "toggleEditingCurrency":
            {
                var currencyAfterChange = state.controls.editingCurrency === EditingCurrency.USD ? EditingCurrency.TOKEN : EditingCurrency.USD;
                var controls6 = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state.controls), {
                    editingCurrency: currencyAfterChange
                });
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state), {
                    controls: controls6
                });
            }
        default:
            return state;
    }
};
var useRoiCalculatorReducer = function(param, initialState) {
    var stakingTokenPrice = param.stakingTokenPrice, earningTokenPrice = param.earningTokenPrice, autoCompoundFrequency = param.autoCompoundFrequency;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(roiCalculatorReducer, lodash_merge__WEBPACK_IMPORTED_MODULE_2___default()(defaultState, initialState)), state = ref[0], dispatch = ref[1];
    // If pool is auto-compounding set state's compounding frequency to this pool's auto-compound frequency
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (autoCompoundFrequency > 0) {
            dispatch({
                type: "setCompoundingFrequency",
                payload: {
                    autoCompoundFrequency: autoCompoundFrequency
                }
            });
        }
    }, [
        autoCompoundFrequency
    ]);
    // Handler for compounding frequency buttons
    var setCompoundingFrequency = function(index) {
        dispatch({
            type: "setCompoundingFrequency",
            payload: {
                index: index
            }
        });
    };
    // Handler for principal input when in USD mode
    var setPrincipalFromUSDValue = function(amount) {
        var principalAsTokenBN = new bignumber_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(amount).div(stakingTokenPrice);
        var principalAsToken = principalAsTokenBN.gt(0) ? principalAsTokenBN.toFixed(TOKEN_PRECISION) : "0.00";
        dispatch({
            type: "setPrincipal",
            payload: {
                principalAsUSD: amount,
                principalAsToken: principalAsToken
            }
        });
    };
    // Handler for principal input when in Token mode
    var setPrincipalFromTokenValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(amount) {
        var principalAsUsdBN = new bignumber_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(amount).times(stakingTokenPrice);
        var principalAsUsdString = principalAsUsdBN.gt(0) ? principalAsUsdBN.toFixed(USD_PRECISION) : "0.00";
        dispatch({
            type: "setPrincipal",
            payload: {
                principalAsUSD: principalAsUsdString,
                principalAsToken: amount
            }
        });
    }, [
        stakingTokenPrice
    ]);
    // Handler for staking duration buttons
    var setStakingDuration = function(stakingDurationIndex) {
        dispatch({
            type: "setStakingDuration",
            payload: stakingDurationIndex
        });
    };
    // Handler for compounding checkbox
    var toggleCompounding = function() {
        dispatch({
            type: "toggleCompounding"
        });
    };
    // Handler for principal input mode switch
    var toggleEditingCurrency = function() {
        dispatch({
            type: "toggleEditingCurrency"
        });
    };
    var setCalculatorMode = function(modeToSet) {
        dispatch({
            type: "setCalculatorMode",
            payload: modeToSet
        });
    };
    // Handler for ROI input
    var setTargetRoi = function(amount) {
        var targetRoiAsTokens = new bignumber_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(amount).div(earningTokenPrice);
        dispatch({
            type: "setTargetRoi",
            payload: {
                roiUSD: +amount,
                roiTokens: targetRoiAsTokens.isNaN() ? 0 : targetRoiAsTokens.toNumber()
            }
        });
    };
    return {
        state: state,
        setPrincipalFromUSDValue: setPrincipalFromUSDValue,
        setPrincipalFromTokenValue: setPrincipalFromTokenValue,
        setStakingDuration: setStakingDuration,
        toggleCompounding: toggleCompounding,
        toggleEditingCurrency: toggleEditingCurrency,
        setCompoundingFrequency: setCompoundingFrequency,
        setCalculatorMode: setCalculatorMode,
        setTargetRoi: setTargetRoi,
        dispatch: dispatch
    };
};
/* harmony default export */ __webpack_exports__["ZP"] = (useRoiCalculatorReducer);
function DefaultCompoundStrategy(param) {
    var state = param.state, apr = param.apr, earningTokenPrice = param.earningTokenPrice, stakingTokenPrice = param.stakingTokenPrice, performanceFee = param.performanceFee, dispatch = param.dispatch;
    var _data = state.data, principalAsUSD = _data.principalAsUSD, roiUSD = _data.roiUSD;
    var _controls = state.controls, compounding = _controls.compounding, compoundingFrequency = _controls.compoundingFrequency, stakingDuration = _controls.stakingDuration, mode = _controls.mode;
    // Calculates and sets ROI whenever related values change
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (mode === CalculatorMode.ROI_BASED_ON_PRINCIPAL) {
            var principalInUSDAsNumber = parseFloat(principalAsUSD);
            var compoundFrequency = compounding ? compoundingFrequency : 0;
            var interestBreakdown = (0,utils_compoundApyHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getInterestBreakdown */ .A1)({
                principalInUSD: principalInUSDAsNumber,
                apr: apr,
                earningTokenPrice: earningTokenPrice,
                compoundFrequency: compoundFrequency,
                performanceFee: performanceFee
            });
            var hasInterest = !Number.isNaN(interestBreakdown[stakingDuration]);
            var roiTokens = hasInterest ? interestBreakdown[stakingDuration] : 0;
            var roiAsUSD = hasInterest ? roiTokens * earningTokenPrice : 0;
            var roiPercentage = hasInterest ? (0,utils_compoundApyHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getRoi */ .Lu)({
                amountEarned: roiAsUSD,
                amountInvested: principalInUSDAsNumber
            }) : 0;
            dispatch({
                type: "setRoi",
                payload: {
                    roiUSD: roiAsUSD,
                    roiTokens: roiTokens,
                    roiPercentage: roiPercentage
                }
            });
        }
    }, [
        principalAsUSD,
        apr,
        stakingDuration,
        earningTokenPrice,
        performanceFee,
        compounding,
        compoundingFrequency,
        mode,
        dispatch, 
    ]);
    // Calculates and sets principal based on expected ROI value
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (mode === CalculatorMode.PRINCIPAL_BASED_ON_ROI) {
            var principalForExpectedRoi = (0,utils_compoundApyHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getPrincipalForInterest */ ._b)(roiUSD, apr, compounding ? compoundingFrequency : 0, performanceFee);
            var principalUSD = !Number.isNaN(principalForExpectedRoi[stakingDuration]) ? principalForExpectedRoi[stakingDuration] : 0;
            var principalToken = new bignumber_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(principalUSD).div(stakingTokenPrice);
            var roiPercentage = (0,utils_compoundApyHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getRoi */ .Lu)({
                amountEarned: roiUSD,
                amountInvested: principalUSD
            });
            dispatch({
                type: "setPrincipalForTargetRoi",
                payload: {
                    principalAsUSD: principalUSD.toFixed(USD_PRECISION),
                    principalAsToken: principalToken.toFixed(TOKEN_PRECISION),
                    roiPercentage: roiPercentage
                }
            });
        }
    }, [
        stakingDuration,
        apr,
        compounding,
        compoundingFrequency,
        mode,
        roiUSD,
        stakingTokenPrice,
        performanceFee,
        dispatch, 
    ]);
    return null;
}


/***/ }),

/***/ 54793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$j": function() { return /* binding */ ClosedTag; },
  "vl": function() { return /* binding */ CommunityTag; },
  "yd": function() { return /* binding */ CompoundingPoolTag; },
  "eE": function() { return /* binding */ CoreTag; },
  "YE": function() { return /* binding */ DualTag; },
  "Vi": function() { return /* binding */ FarmAuctionTag; },
  "EM": function() { return /* binding */ ManualPoolTag; },
  "Re": function() { return /* binding */ SoonTag; },
  "_6": function() { return /* binding */ VoteNowTag; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/uikit/src/components/Tag/Tag.tsx + 3 modules
var Tag = __webpack_require__(24930);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Verified.tsx
var Verified = __webpack_require__(29502);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(36544);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/TooltipText.tsx
var TooltipText = __webpack_require__(17634);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Community.tsx
var Community = __webpack_require__(11051);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Refresh.tsx
var Refresh = __webpack_require__(49266);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(19729);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(17058);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Svg/Icons/Vote.tsx





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M2 21.8966H12C12.55 21.8966 13 22.3466 13 22.8966C13 23.4466 12.55 23.8966 12 23.8966H2C1.45 23.8966 1 23.4466 1 22.8966C1 22.3466 1.45 21.8966 2 21.8966ZM5.24 8.96661L8.07 6.13661L20.8 18.8666C21.58 19.6466 21.58 20.9166 20.8 21.6966C20.02 22.4766 18.75 22.4766 17.97 21.6966L5.24 8.96661ZM13.73 3.30661L16.56 6.13661C17.34 6.91661 17.34 8.18661 16.56 8.96661L15.14 10.3866L9.49 4.72661L10.9 3.31661C11.68 2.52661 12.95 2.52661 13.73 3.30661ZM3.83 10.3766L9.49 16.0366L8.08 17.4466C7.3 18.2266 6.03 18.2266 5.25 17.4466L2.42 14.6166C1.64 13.8366 1.64 12.5666 2.42 11.7866L3.83 10.3766Z"
        })
    }));
};
/* harmony default export */ var Vote = (Icon);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Timer.tsx
var Timer = __webpack_require__(22491);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Block.tsx
var Block = __webpack_require__(62395);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/components/Tags.tsx







var CoreTag = function(props) {
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variant: "secondary",
        outline: true,
        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Verified/* default */.Z, {
            width: "18px",
            color: "secondary",
            mr: "4px"
        })
    }, props), {
        children: t("Core")
    }));
};
var FarmAuctionTagToolTipContent = /*#__PURE__*/ (0,react.memo)(function() {
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        color: "text",
        children: t("Farm Auction Winner, add liquidity at your own risk.")
    });
});
var FarmAuctionTag = function(props) {
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(FarmAuctionTagToolTipContent, {}), {
        placement: "right"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                ref: targetRef,
                style: {
                    textDecoration: "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    variant: "failure",
                    outline: true,
                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Community/* default */.Z, {
                        width: "18px",
                        color: "failure",
                        mr: "4px"
                    })
                }, props), {
                    children: t("Farm Auction")
                }))
            })
        ]
    });
};
var CommunityTag = function(props) {
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variant: "failure",
        outline: true,
        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Community/* default */.Z, {
            width: "18px",
            color: "failure",
            mr: "4px"
        })
    }, props), {
        children: t("Community")
    }));
};
var DualTag = function(props) {
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variant: "textSubtle",
        outline: true
    }, props), {
        children: t("Dual")
    }));
};
var ManualPoolTag = function(props) {
    var t = (0,Localization/* useTranslation */.$G)().t;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var variantconst = theme.isDark ? "textSubtle" : "failure";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variant: variantconst,
        outline: true,
        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Refresh/* default */.Z, {
            width: "18px",
            color: variantconst,
            mr: "4px"
        })
    }, props), {
        children: t("Auto")
    }));
};
var CompoundingPoolTag = function(props) {
    var t = (0,Localization/* useTranslation */.$G)().t;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var variantconst = theme.isDark ? "textSubtle" : "failure";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variant: variantconst,
        outline: true,
        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
            width: "18px",
            color: variantconst,
            mr: "4px"
        })
    }, props), {
        children: t("Auto")
    }));
};
var VoteNowTag = function(props) {
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variant: "success",
        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Vote, {
            width: "18px",
            color: "success",
            mr: "4px"
        })
    }, props), {
        children: t("Vote Now")
    }));
};
var SoonTag = function(props) {
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variant: "binance",
        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Timer/* default */.Z, {
            width: "18px",
            color: "success",
            mr: "4px"
        })
    }, props), {
        children: t("Soon")
    }));
};
var ClosedTag = function(props) {
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variant: "textDisabled",
        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
            width: "18px",
            color: "textDisabled",
            mr: "4px"
        })
    }, props), {
        children: t("Closed")
    }));
};



/***/ }),

/***/ 95239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ TokenImage; },
/* harmony export */   "q": function() { return /* binding */ TokenPairImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44747);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56503);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12764);
/* harmony import */ var config_constants_tokens__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29748);





var getImageUrlFromToken = function(token) {
    var address = token.symbol === "BNB" ? config_constants_tokens__WEBPACK_IMPORTED_MODULE_1__/* ["default"].wbnb.address */ .ZP.wbnb.address : token.address;
    return "https://moon.biz/images/tokens/".concat(address, ".png");
};
var TokenPairImage = function(_param) {
    var primaryToken = _param.primaryToken, secondaryToken = _param.secondaryToken, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "primaryToken",
        "secondaryToken"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        primarySrc: getImageUrlFromToken(primaryToken),
        secondarySrc: getImageUrlFromToken(secondaryToken)
    }, props));
};
var TokenImage = function(_param) {
    var token = _param.token, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "token"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: getImageUrlFromToken(token)
    }, props));
};


/***/ }),

/***/ 90834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hf": function() { return /* binding */ useBNBBusdPrice; },
/* harmony export */   "S9": function() { return /* binding */ useCakeBusdPrice; },
/* harmony export */   "Tx": function() { return /* binding */ useBUSDCakeAmount; },
/* harmony export */   "ZP": function() { return /* binding */ useBUSDPrice; }
/* harmony export */ });
/* unused harmony exports useSattBusdPrice, useBUSDCurrencyAmount */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9941);
/* harmony import */ var _moonbiz_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64922);
/* harmony import */ var config_constants_tokens__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29748);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64011);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var utils_prices__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7879);
/* harmony import */ var _utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53854);
/* harmony import */ var _usePairs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84915);








var WBNB = config_constants_tokens__WEBPACK_IMPORTED_MODULE_1__/* ["default"].wbnb */ .ZP.wbnb, busd = config_constants_tokens__WEBPACK_IMPORTED_MODULE_1__/* ["default"].busd */ .ZP.busd;
/**
 * Returns the price in BUSD of the input currency
 * @param currency currency to compute the BUSD price of
 */ function useBUSDPrice(currency) {
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().chainId;
    var wrapped = (0,_utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_5__/* .wrappedCurrency */ .pu)(currency, chainId);
    var tokenPairs = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return [
            [
                chainId && wrapped && (0,_moonbiz_sdk__WEBPACK_IMPORTED_MODULE_0__/* .currencyEquals */ .KA)(WBNB, wrapped) ? undefined : currency,
                chainId ? WBNB : undefined
            ],
            [
                (wrapped === null || wrapped === void 0 ? void 0 : wrapped.equals(busd)) ? undefined : wrapped,
                busd
            ],
            [
                chainId ? WBNB : undefined,
                busd
            ], 
        ];
    }, [
        chainId,
        currency,
        wrapped
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_usePairs__WEBPACK_IMPORTED_MODULE_6__/* .usePairsNFT */ .j_)(tokenPairs), 3), ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(ref[0], 2), ethPairState = ref1[0], ethPair = ref1[1], ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(ref[1], 2), busdPairState = ref2[0], busdPair = ref2[1], ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(ref[2], 2), busdEthPairState = ref3[0], busdEthPair = ref3[1];
    return (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        if (!currency || !wrapped || !chainId) {
            return undefined;
        }
        // handle weth/eth
        if (wrapped.equals(WBNB)) {
            if (busdPair) {
                var price = busdPair.priceOf(WBNB);
                return new _moonbiz_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Price */ .tA(currency, busd, price.denominator, price.numerator);
            }
            return undefined;
        }
        // handle busd
        if (wrapped.equals(busd)) {
            return new _moonbiz_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Price */ .tA(busd, busd, "1", "1");
        }
        var ethPairETHAmount = ethPair === null || ethPair === void 0 ? void 0 : ethPair.reserveOf(WBNB);
        var ethPairETHBUSDValue = ethPairETHAmount && busdEthPair ? busdEthPair.priceOf(WBNB).quote(ethPairETHAmount).raw : _moonbiz_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(0);
        // all other tokens
        // first try the busd pair
        if (busdPairState === _usePairs__WEBPACK_IMPORTED_MODULE_6__/* .PairState.EXISTS */ ._G.EXISTS && busdPair && busdPair.reserveOf(busd).greaterThan(ethPairETHBUSDValue)) {
            var price1 = busdPair.priceOf(wrapped);
            return new _moonbiz_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Price */ .tA(currency, busd, price1.denominator, price1.numerator);
        }
        if (ethPairState === _usePairs__WEBPACK_IMPORTED_MODULE_6__/* .PairState.EXISTS */ ._G.EXISTS && ethPair && busdEthPairState === _usePairs__WEBPACK_IMPORTED_MODULE_6__/* .PairState.EXISTS */ ._G.EXISTS && busdEthPair) {
            if (busdEthPair.reserveOf(busd).greaterThan("0") && ethPair.reserveOf(WBNB).greaterThan("0")) {
                var ethBusdPrice = busdEthPair.priceOf(busd);
                var currencyEthPrice = ethPair.priceOf(WBNB);
                var busdPrice = ethBusdPrice.multiply(currencyEthPrice).invert();
                return new _moonbiz_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Price */ .tA(currency, busd, busdPrice.denominator, busdPrice.numerator);
            }
        }
        return undefined;
    }, [
        chainId,
        currency,
        ethPair,
        ethPairState,
        busdEthPair,
        busdEthPairState,
        busdPair,
        busdPairState,
        wrapped
    ]);
}
var useCakeBusdPrice = function() {
    var cakeBusdPrice = useBUSDPrice(config_constants_tokens__WEBPACK_IMPORTED_MODULE_1__/* ["default"].rp1 */ .ZP.rp1);
    return cakeBusdPrice;
};
var useSattBusdPrice = function() {
    var sattBusdPrice = useBUSDPrice(tokens.satt);
    return sattBusdPrice;
};
var useBUSDCurrencyAmount = function(currency, amount) {
    var chainId = useActiveWeb3React().chainId;
    var busdPrice = useBUSDPrice(currency);
    var wrapped = wrappedCurrency(currency, chainId);
    if (busdPrice) {
        return multiplyPriceByAmount(busdPrice, amount, wrapped.decimals);
    }
    return undefined;
};
var useBUSDCakeAmount = function(amount) {
    var cakeBusdPrice = useCakeBusdPrice();
    if (cakeBusdPrice) {
        return (0,utils_prices__WEBPACK_IMPORTED_MODULE_4__/* .multiplyPriceByAmount */ .as)(cakeBusdPrice, amount);
    }
    return undefined;
};
var useBNBBusdPrice = function() {
    var bnbBusdPrice = useBUSDPrice(config_constants_tokens__WEBPACK_IMPORTED_MODULE_1__/* ["default"].wbnb */ .ZP.wbnb);
    return bnbBusdPrice;
};


/***/ }),

/***/ 43452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A1": function() { return /* binding */ getInterestBreakdown; },
/* harmony export */   "Lu": function() { return /* binding */ getRoi; },
/* harmony export */   "_b": function() { return /* binding */ getPrincipalForInterest; },
/* harmony export */   "g5": function() { return /* binding */ getApy; }
/* harmony export */ });
// 1 day, 7 days, 30 days, 1 year, 5 years
var DAYS_TO_CALCULATE_AGAINST = [
    1,
    7,
    30,
    365,
    1825
];
/**
 *
 * @param principalInUSD - amount user wants to invest in USD
 * @param apr - farm or pool apr as percentage. If its farm APR its only cake rewards APR without LP rewards APR
 * @param earningTokenPrice - price of reward token
 * @param compoundFrequency - how many compounds per 1 day, e.g. 1 = one per day, 0.142857142 - once per week
 * @param performanceFee - performance fee as percentage
 * @returns an array of token values earned as interest, with each element representing interest earned over a different period of time (DAYS_TO_CALCULATE_AGAINST)
 */ var getInterestBreakdown = function(param) {
    var principalInUSD = param.principalInUSD, apr = param.apr, earningTokenPrice = param.earningTokenPrice, _compoundFrequency = param.compoundFrequency, compoundFrequency = _compoundFrequency === void 0 ? 1 : _compoundFrequency, _performanceFee = param.performanceFee, performanceFee = _performanceFee === void 0 ? 0 : _performanceFee;
    // Everything here is worked out relative to a year, with the asset compounding at the compoundFrequency rate. 1 = once per day
    var timesCompounded = 365 * compoundFrequency;
    // We use decimal values rather than % in the math for both APY and the number of days being calculates as a proportion of the year
    var aprAsDecimal = apr / 100;
    // special handling for tokens like tBTC or BIFI where the daily token rewards for $1000 dollars will be less than 0.001 of that token
    // and also cause rounding errors
    var isHighValueToken = Math.round(earningTokenPrice / 1000) > 0;
    var roundingDecimalsNew = isHighValueToken ? 5 : 3;
    return DAYS_TO_CALCULATE_AGAINST.map(function(days) {
        var daysAsDecimalOfYear = days / 365;
        // Calculate the starting TOKEN balance with a dollar balance of principalInUSD.
        var principal = principalInUSD / earningTokenPrice;
        var interestEarned = principal * aprAsDecimal * (days / 365);
        if (timesCompounded !== 0) {
            // This is a translation of the typical mathematical compounding APY formula. Details here: https://www.calculatorsoup.com/calculators/financial/compound-interest-calculator.php
            var accruedAmount = principal * Math.pow(1 + aprAsDecimal / timesCompounded, timesCompounded * daysAsDecimalOfYear);
            // To get the TOKEN amount earned, deduct the amount after compounding (accruedAmount) from the starting TOKEN balance (principal)
            interestEarned = accruedAmount - principal;
            if (performanceFee) {
                var performanceFeeAsDecimal = performanceFee / 100;
                var performanceFeeAsAmount = interestEarned * performanceFeeAsDecimal;
                interestEarned -= performanceFeeAsAmount;
            }
        }
        return parseFloat(interestEarned.toFixed(roundingDecimalsNew));
    });
};
/**
 * @param interest how much USD amount you aim to make
 * @param apr APR of farm/pool
 * @param compoundingFrequency how many compounds per 1 day, e.g. 1 = one per day, 0.142857142 - once per week
 * @returns an array of principal values needed to reach target interest, with each element representing principal needed for a different period of time (DAYS_TO_CALCULATE_AGAINST)
 */ var getPrincipalForInterest = function(interest, apr, compoundingFrequency) {
    var performanceFee = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    return DAYS_TO_CALCULATE_AGAINST.map(function(days) {
        var apyAsDecimal = getApy(apr, compoundingFrequency, days, performanceFee);
        return parseFloat((interest / apyAsDecimal).toFixed(2));
    });
};
/**
 * Given APR returns APY
 * @param apr APR as percentage
 * @param compoundFrequency how many compounds per day
 * @param days if other than 365 adjusts (A)PY for period less than a year
 * @param performanceFee performance fee as percentage
 * @returns APY as decimal
 */ var getApy = function(apr) {
    var compoundFrequency = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, days = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 365, performanceFee = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var daysAsDecimalOfYear = days / 365;
    var aprAsDecimal = apr / 100;
    var timesCompounded = 365 * compoundFrequency;
    var apyAsDecimal = apr / 100 * daysAsDecimalOfYear;
    if (timesCompounded > 0) {
        apyAsDecimal = Math.pow(1 + aprAsDecimal / timesCompounded, timesCompounded * daysAsDecimalOfYear) - 1;
    }
    if (performanceFee) {
        var performanceFeeAsDecimal = performanceFee / 100;
        var takenAsPerformanceFee = apyAsDecimal * performanceFeeAsDecimal;
        apyAsDecimal -= takenAsPerformanceFee;
    }
    return apyAsDecimal;
};
var getRoi = function(param) {
    var amountEarned = param.amountEarned, amountInvested = param.amountInvested;
    if (amountInvested === 0) {
        return 0;
    }
    var percentage = amountEarned / amountInvested * 100;
    return percentage;
};


/***/ }),

/***/ 76582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _moonbiz_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64922);
/* harmony import */ var config_constants_networks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70457);
/* harmony import */ var state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9640);
/* harmony import */ var state_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45101);




/**
 * Function to return gasPrice outwith a react component
 */ var getGasPrice = function() {
    var chainId = config_constants_networks__WEBPACK_IMPORTED_MODULE_3__/* .CHAIN_ID */ .K;
    var state = state__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .ZP.getState();
    var userGas = state.user.gasPrice || state_types__WEBPACK_IMPORTED_MODULE_2__/* .GAS_PRICE_GWEI["default"] */ .j4["default"];
    return chainId === _moonbiz_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.MAINNET.toString */ .a_.MAINNET.toString() ? userGas : state_types__WEBPACK_IMPORTED_MODULE_2__/* .GAS_PRICE_GWEI.testnet */ .j4.testnet;
};
/* harmony default export */ __webpack_exports__["Z"] = (getGasPrice);


/***/ }),

/***/ 12157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isUndefinedOrNull; }
/* harmony export */ });
function isUndefinedOrNull(value) {
    return value === null || value === undefined;
}


/***/ }),

/***/ 11438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ latinise; }
/* harmony export */ });
/* unused harmony export Latinise */
var Latinise = {
    latin_map: {
        τ: "t",
        Τ: "T"
    }
};
var latinise = function(input) {
    return input.replace(/[^A-Za-z0-9[\] ]/g, function(x) {
        return Latinise.latin_map[x] || x;
    });
};


/***/ }),

/***/ 95704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48732);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44850);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9355);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(54103);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(49679);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(90452);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5324);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(20253);
/* harmony import */ var ethers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89706);
/* harmony import */ var _state_satt_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12049);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var WalletWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a7017c73-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var SattPasswordModal = function(param) {
    var _onDismiss = param.onDismiss, onDismiss = _onDismiss === void 0 ? function() {
        return null;
    } : _onDismiss, confirmSattTransaction = param.confirmSattTransaction, ShowSattPasswordModal = param.ShowSattPasswordModal;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), sattPassword = ref[0], setSattPassword = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isWorning = ref1[0], setIsWorning = ref1[1];
    var getSattSigner = (0,_state_satt_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useSattWallet */ .M)().getSattSigner;
    var handlePassChange = function(event) {
        setIsWorning(false);
        setSattPassword(event.target.value);
    };
    var onPressConfirmSatt = function() {
        var signer = getSattSigner(sattPassword);
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(signer, ethers__WEBPACK_IMPORTED_MODULE_7__/* .Wallet */ .w5)) {
            confirmSattTransaction(sattPassword);
            onDismiss();
        } else {
            setIsWorning(true);
        }
    };
    if (ShowSattPasswordModal) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            minWidth: "320px",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* .ModalBody */ .fe, {
                width: [
                    "400px",
                    null,
                    "400px"
                ],
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(WalletWrapper, {
                        p: "15px",
                        maxHeight: "453px",
                        overflowY: "auto",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                textAlign: "center",
                                color: "#1F2349",
                                mb: "10px",
                                fontSize: "16px",
                                fontFamily: "Poppins-bold",
                                fontWeight: "400",
                                lineHeight: "130%",
                                children: "Please enter your satt wallet password"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                m: "10px",
                                onChange: handlePassChange,
                                placeholder: "Password",
                                type: "password",
                                isWarning: isWorning
                            }),
                            isWorning && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                my: "10px",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    color: "red",
                                    textAlign: "center",
                                    children: "Incorrect password"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        p: "24px",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            width: "100%",
                            onClick: onPressConfirmSatt,
                            bgColor: "#7F84FF",
                            children: "Confirm Satt Transaction"
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        title: "Confirm Satt Transaction",
        headerBackground: "gradients.cardHeader",
        onDismiss: onDismiss,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            minWidth: "320px",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* .ModalBody */ .fe, {
                width: [
                    "320px",
                    null,
                    "340px"
                ],
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(WalletWrapper, {
                        p: "15px",
                        maxHeight: "453px",
                        overflowY: "auto",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                textAlign: "left",
                                color: "textSubtle",
                                as: "p",
                                mb: "5px",
                                children: "Please enter your satt wallet password"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                m: "10px",
                                onChange: handlePassChange,
                                placeholder: "Password",
                                type: "password",
                                isWarning: isWorning
                            }),
                            isWorning && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                my: "10px",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    color: "red",
                                    textAlign: "center",
                                    children: "Incorrect password"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        p: "24px",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            width: "100%",
                            onClick: onPressConfirmSatt,
                            children: "Confirm Satt Transaction"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SattPasswordModal);


/***/ })

}]);